import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from 'App';
import { GlobalStyles } from 'globalStyles';
import { ApolloProvider } from '@apollo/client';
import { client } from 'api/ApolloClient';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Router>
        <App />
        <GlobalStyles />
      </Router>
    </ApolloProvider>
  </React.StrictMode>
);
